import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import { Validator } from 'vee-validate';
import Paginate from 'vuejs-paginate';
import VueElementLoading from 'vue-element-loading';
import PageTracker from '../../../common/PageTrackerHelper'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';;


export default {
  name: 'EmpCategories',
  components: {
      Multiselect,
      VueElementLoading,
      Paginate
  },
  mixins:[PageTracker],
  data: function() {
      return {
        newCategoryList : [],
        empCategories:[],
        FilterdData:[],
        Loading:false,
      }
  },
  created: function() {
  },
async mounted(){
    this.userDataKey = window.localStorage.getItem('userUniqueKey');
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
    this.localhubdetails = userdetail.hubdetails[0];
    // this.hubinfo  = await this.getHubDetailsbyID(this.localuserid, this.localhubdetails);
    // console.log('Mixin is working for :',userdetail);
    // let getHubList = localStorage.getItem('allhubaccesslist');
    // var byteHub = CryptoJS.AES.decrypt(getHubList.toString(), this.userDataKey);
    // var hubList = byteHub.toString(CryptoJS.enc.Utf8);
    // this.hubAccessList = JSON.parse(hubList);
    this.getEmpCategories();

  },
  methods : {
    

    getEmpCategories(){
        this.Loading=true;
        // this.filterCatCount= this.FilterdData.length;
       let url = 'user/migration/getemployeetypemasterlist';
        let payload={"appkey":"^$LAST^$Mile%#^$"}
       axios.post(apiUrl.api_url + url,payload)
         .then((response) => {
             if(response.data.code ==200){
                this.Loading=false;
                // console.log("hiii", response)
                this.empCategories=response.data.data.rows;
                this.FilterdData=response.data.FilterdData.rows;
				this.newCategoryList=[...this.FilterdData];
             }else{
                this.$alertify.error(response.data.message);
                this.Loading=false;
             }
         })
         .catch((httpException) => {
               this.$alertify.error("Categories not found");
               this.Loading=false;
               console.error('exception is:::::::::', httpException)
         })
     },

     pushToFiltered(e,Category, index){
        const duplicate = this.FilterdData.some(category => category.EmpTypeId === Category.EmpTypeId);
        const checkbox = e.target;
        if(duplicate && checkbox.checked){
            this.$alertify.error("Already exists in active category list");
            checkbox.checked=false;
        }else{
            if (checkbox.checked) {
                Category.isNew=true;
                this.FilterdData.push(Category);
                this.newCategoryList.push(Category)
            } else {
                // let arrayIndex =this.FilterdData.length-1;
                const arrayIndex = this.FilterdData.findIndex(obj => obj.EmpTypeId === Category.EmpTypeId);
                console.log("hiielse",  arrayIndex);
               this.FilterdData.splice(arrayIndex,1)
			   this.newCategoryList.splice(arrayIndex,1)
               console.log("hiielse",  this.FilterdData);
            }
        }
		console.log("FilteredData", this.FilterdData)
     },

     removeFromFiltered(e, Category, index){
        console.log(index,"----------");
        let oldCategoryList=this.newCategoryList;
		const checkbox = e.target;
		if(checkbox.checked) {
                // this.FilterdData.push(Category);
                oldCategoryList.push(Category)
            } else {
            //    this.FilterdData.splice(index,1)
                    // if(index!=0){
                    //     oldCategoryList.splice(index-1,1)
                    // }else{
                        oldCategoryList.splice(index,1)
                    // }
			  
            }
            console.log("<><><><>", oldCategoryList)
           this.newCategoryList=oldCategoryList;
        console.log("<><><><>", this.newCategoryList)
     },

     submitCategory(){
        let EmptypeId = [];
        this.Loading=true;
        if(this.newCategoryList.length==0){
            this.$alertify.error("Active categories list - One Category must be selected..!!");
            // this.FilterdData=[]
        }
        console.log("this.newCategoryList",this.newCategoryList);
        
        if(this.newCategoryList.length > 0 ){
            this.newCategoryList.map(empCat=>{
                EmptypeId.push(empCat.EmpTypeId)
          })
        }
      
        let data={
            data:EmptypeId,
            createdby:this.localusermailid
        }

        axios.post(apiUrl.api_url + 'user/migration/getemployeetypemasterlistUpdateinRedis',data)
        .then((response) => {
          if(response.data.code == 200){
            const checkboxes = document.querySelectorAll('.categories');
            const ActCheckboxes = document.querySelectorAll('.ActiveCat');
            // Loop through each checkbox and uncheck it
            checkboxes.forEach(checkbox => {
                checkbox.checked = false;
            });
            ActCheckboxes.forEach(Activecheck=>{
                Activecheck.checked = true;
            })
			this.$alertify.success("Categories updated successfully..!!");
			this.getEmpCategories()
          }else{
            this.$alertify.error(response.data.message);
            this.Loading=false;
          }
        })
      .catch((httpException) => {
          console.error('exception is:::::::::',httpException)
          this.Loading=false;
      });
     }
 

  },
}



// WEBPACK FOOTER //
// ./src/views/components/EmpCategories/EmpCategories.component.js